import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_DISCIPLINE,
    fetchDisciplineSuccessful
} from '../actions'



function * fetchDiscipline (paylaod){
    try{
       const response=  yield call(DCore.get, '/disciplines')
        yield put (fetchDisciplineSuccessful(response.data))

    }catch(e){
        console.log("some thing went wrong", e)
    }
}



export function * disciplineSaga(){
    yield takeLatest(FETCH_DISCIPLINE,fetchDiscipline)
}